import React, { Component } from 'react';
import './Footer.css';

export class Footer extends Component {
    render() {
        return (
            <div className="footer">
                <div className="center-content">
                    <a className="usaa-button2 usaa-button2--primary feedback-button" href="https://search.usaajobs.com/">Join our team!</a>
                    <div className="footer-text">
                        <p>©2018,&nbsp;&nbsp;USAA. All rights reserved.</p>
                    </div>

                    <div className="social-media-outlets">
                        <a
                            href="https://www.facebook.com/USAA/"
                            className="fa fa-facebook"
                            aria-label="Facebook"
                            title="Visit USAA on Facebook">&nbsp;</a>
                        <a
                            href="https://twitter.com/USAA"
                            className="fa fa-twitter"
                            aria-label="Twitter"
                            title="Visit USAA on Twitter">&nbsp;</a>
                        <a
                            href="https://plus.google.com/+usaa"
                            className="fa fa-google"
                            aria-label="Google"
                            title="Visit USAA on Google">&nbsp;</a>
                        <a
                            href="https://www.linkedin.com/company/usaa"
                            className="fa fa-linkedin"
                            aria-label="Linked in"
                            title="Visit USAA on LinkedIn">&nbsp;</a>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Footer.js